// Cadre commun des écrans d'administration (G01 à G05, charte D-038) : menu latéral des rubriques, en-tête
// de page (titre, description, action principale), contenu.

import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { useSession } from '../../app/session';
import { libelleRole } from '../../composants/format';

const RUBRIQUES: [string, string][] = [
  ['/administration/organisations', 'Organisations'],
  ['/administration/utilisateurs', 'Comptes utilisateurs'],
  ['/administration/roles', 'Rôles et droits'],
  ['/administration/parametres', 'Paramètres'],
  ['/administration/journal', 'Journal d’audit'],
];
const REFERENTIEL: [string, string][] = [
  ['/referentiel/doublons', 'Doublons à traiter'],
  ['/referentiel/installations/nouvelle', 'Nouvelle installation'],
  ['/catalogue', 'Catalogue'],
];

export interface Ancre {
  id: string;
  libelle: string;
}

export function CadreAdministration({
  titre,
  contexte,
  description,
  action,
  ancres,
  children,
}: {
  titre: string;
  contexte?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  ancres?: Ancre[];
  children: ReactNode;
}) {
  const { etat } = useSession();
  const u = etat?.utilisateur;
  return (
    <div className="avec-menu page-administration">
      <nav className="menu-lateral" aria-label="Administration">
        <span className="sur-titre">Administration</span>
        <ul>
          {RUBRIQUES.map(([chemin, libelle]) => (
            <li key={chemin}>
              <NavLink to={chemin} end={false}>
                {libelle}
              </NavLink>
              {ancres && chemin === '/administration/parametres' && (
                <ul className="ancres">
                  {ancres.map((a) => (
                    <li key={a.id}>
                      <a href={`#${a.id}`}>{a.libelle}</a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <span className="sur-titre espace-haut">Référentiel</span>
        <ul>
          {REFERENTIEL.map(([chemin, libelle]) => (
            <li key={chemin}>
              <NavLink to={chemin} end>
                {libelle}
              </NavLink>
            </li>
          ))}
        </ul>
        {u && (
          <p className="menu-utilisateur">
            <b>
              {u.prenom} {u.nom}
            </b>
            <span>{etat?.roles?.map(libelleRole).join(', ')}</span>
          </p>
        )}
      </nav>
      <div className="menu-contenu">
        <div className="page-tete">
          <div>
            {contexte && <span className="contexte">{contexte}</span>}
            <h1>{titre}</h1>
            {description && <p>{description}</p>}
          </div>
          {action}
        </div>
        {children}
      </div>
    </div>
  );
}
